module.exports = __webpack_public_path__ + "static/img/btn-dk.5e3f703e.png";